exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cardBackground[data-v-33e3ad65]{background-image:linear-gradient(to top right,#212121,#212121);box-shadow:10px 10px 10px hsla(332,8%,52%,.1);border-radius:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33e3ad65","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/baseView.vue
// module id = 555
// module chunks = 0